
export const getObject = (state) => {
  let {
    creation,
    type,
    description,
    size,
    file
  } = state.addFile
  let name = file ? file.name : undefined
  return {
    creation,
    type,
    description,
    size,
    file,
    name
  }
}

export const getArray = (state) => {
  return state.list.map((key) => {
    return {
      ...state._[key],
      key
    }
  })
}

export const getTotalSize = (state) => {
  return state.list.reduce((acc, value) => {
    let obj = state._[value]
    if (obj.size) {
      return acc + obj.size
    }
    return acc
  }, 0)
}

export const getElement = (state) => (key) => {
  return {
    ...state._[key],
    key
  }
}

export const apificate = (state, getters) => {
  return state.list.map((key) => {
    let x = state._[key]
    return x
    // let detail = cleanObject(x)
    // return detail
  })
}
